
import { defineComponent } from "vue";
import { IUsersModel } from "@/interfaces/modules/security/IUsersModel";
import { IDutiesModel } from "@/interfaces/modules/security/IDutiesModel";
import UsersService from "@/api/Security/UsersService";
import DutiesService from "@/api/Security/DutiesService";
import store from "@/store";
import router from "@/router";
import { UserLoginStatus, UserLoginStatusLabels } from '@/enums';

export default defineComponent({
  name: "App",
  data() {
    return {
      roles: [] as IDutiesModel[],

      form: {
        loading: true,
        dialog: false,
        valid: false,
        record: {} as IUsersModel,
        rules: {
          required: [(v: any) => !!v || "Este campo es requerido"],
        },
      },
      table: {
        filters: {
          search: "",
        },
        currentPage: 1,
        loading: false,
        headers: [
          {
            key: "FirstName",
            label: "Nombre",
            sortable: true,
          },
          {
            key: "LastName",
            label: "Apellido",
            sortable: true,
          },
          {
            key: "Email",
            label: "Correo / Usuario",
            sortable: true,
          },

          {
            key: "Status",
            label: "Activo",
            sortable: true,
          },
          {
            key: "CreatedByFormat",
            label: "Creación",
            sortable: true,
          },
          {
            key: "ModifiedByFormat",
            label: "Ultima modificación",
            sortable: true,
          },
          {
            key: "action",
            label: "Acciones",
            sortable: false,
          },
        ],
        records: [],
        rowsPerPage: 10,
      } as any,
    };
  },
  computed: {
    filteredItems(): any {
      return this.table.filters.search
        ? this.table.records.filter(
          (item: any) =>
            item.UserName.toLowerCase().includes(
              this.table.filters.search.toLowerCase()
            ) ||
            item.Email.toLowerCase().includes(
              this.table.filters.search.toLowerCase()
            )
        )
        : this.table.records;
    },
    formRecord(): any {
      return this.$refs.formRecord;
    },
    rows(): any {
      return this.table.records?.length || 0;
    },
  },

  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.table.loading = true;
      this.table.records = await UsersService.GetSystemUsers();
      this.roles = await DutiesService.GetSystemDuties();
      this.table.loading = false;
    },
    async edit(data: IUsersModel) {
      this.form.record = await UsersService.GetSystemUsersbyId(data);
      this.form.dialog = true;
    },
    editUser(Id: any) {
      router.push(`users/edit/${Id}`);
    },
    getStatusLabel(status: any) {
      return UserLoginStatusLabels[status] || 'Desconocido';
    },
    getStatusCss(status: any) {
      if (status === UserLoginStatus.Activo)
        return "badge text-outline-success";
      else if (status === UserLoginStatus.Bloqueado)
        return "badge text-outline-info";
      else
        return "badge text-outline-danger";
    },
    validateState(field: any): boolean {
      return this.form.record[field]?.length > 0 ? true : false;
    },
    async handleSubmit(event) {
      event.preventDefault();
      this.form.dialog = false;
      await UsersService.PostSystemUsers(this.form.record);
      store.dispatch("core/popupDialog", {
        text: "Registro completado con éxito.",
        type: "success",
        showCancelButton: false,
      });

      this.load();
    },
  },
});
